// extracted by mini-css-extract-plugin
export default {"message":"minimum-price-message__message___BxyHV"};